import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import Accordion from "react-bootstrap/Accordion";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useParams } from "react-router-dom";
import IsLoading from "../../components/Loading/IsLoading";
import {
  instructorApi,
  useGetCourseDetailQuery,
} from "../../api/instructorApi";
import {
  useDownloadMaterialFileMutation,
  useRemoveMaterialAsyncMutation,
  useUploadMaterialFileMutation,
} from "../../api/materialApi";
import JSZip from "jszip";
import {
  useAddVideoAsyncMutation,
  useChangeVideoAsncMutation,
  useGetWatchVideoUrlMutation,
  useRemoveVideoAsyncMutation,
  useUpdateVideoAsyncMutation,
  useGetUnAssignedVideosAsyncQuery,
  useUpdateAssignVideoAsyncMutation,
  uploadVideoWithProgress,
  changeVideoWithProgress,
} from "../../api/videoApi";
import VideoPage from "../LessonPage/VideoPage";
import { CiCircleRemove } from "react-icons/ci";
import {
  useAddSectionAsyncMutation,
  useRemoveSectionAsyncMutation,
  useUpdateSectionAsyncMutation,
  useUpdateSectionRowsMutation,
} from "../../api/sectionApi";
import { useDispatch } from "react-redux";
import CustomModal from "../CustomComponents/CustomModal";
import InstructorAuth from "../../Wrappers/HoC/InstructorAuth";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Input } from "reactstrap";
import { toast } from "react-toastify";
import { IoPencil } from "react-icons/io5";
import Spinner from "react-bootstrap/Spinner";
import { useEvaluateUpdateCourseMutation } from "../../api/courseApi";
import { courseEvaluateEnum } from "../../api/Enums/evaluateEnum";
import { useSelector } from "react-redux";
import EvaluateModal from "../CustomComponents/EvaluateModal";
import Roles from "../../Constants/Roles";
import { useTranslation } from "react-i18next";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { createContext } from "react";
import { IoRefresh } from "react-icons/io5";
import { 
  FiEdit2, FiTrash2, FiPlus, FiVideo, FiUpload, FiDownload, 
  FiX, FiPlay, FiGripVertical, FiCheckCircle, FiAlertCircle,
  FiChevronUp, FiChevronDown
} from "react-icons/fi";
import VideoUploadProgress from "./VideoUploadProgress";
import './InstructorsCourseDetail.css';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "80vh",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "12px",
  boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
  p: 4,
};
const VideoRefContext = createContext();

function InstructorsCourseDetail() {
  const videoRef = useRef();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const buttonRef = useRef(null);
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const { slug } = useParams();
  const { data, isLoading } = useGetCourseDetailQuery(slug);
  const [downloadFile] = useDownloadMaterialFileMutation();
  const userId = useSelector((state) => state.authStore.nameIdentifier);
  const [watchingVideo] = useGetWatchVideoUrlMutation();
  const [removeVideoAsync] = useRemoveVideoAsyncMutation();
  const [removeSectionAsync] = useRemoveSectionAsyncMutation();
  const [changeVideoAsync] = useChangeVideoAsncMutation();
  const [addVideoAsync] = useAddVideoAsyncMutation();
  const [updateSectionAsync] = useUpdateSectionAsyncMutation();
  const [uploadMaterialAsync] = useUploadMaterialFileMutation();
  const [removeMaterialAsync] = useRemoveMaterialAsyncMutation();
  const [updateVideoAsync] = useUpdateVideoAsyncMutation();
  const [updateEvaluate] = useEvaluateUpdateCourseMutation();
  const [updateSectionRows] = useUpdateSectionRowsMutation();
  const [updateAssignVideoAsync] = useUpdateAssignVideoAsyncMutation(); // Add this hook
  const [title, setTitle] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [chooseVideo, setChooseVideo] = useState(false);
  const [sections, setSections] = useState([]);
  const [modal, isShowModal] = useState(false);
  const [evaluateModal, setEvaluateModal] = useState(false);
  const [createSectionAsync] = useAddSectionAsyncMutation();
  const [isEnable, setIsEnable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [handleClickedUpdateRows, setHandleClickedUpdateRows] = useState(false);
  const [editingSectionId, setEditingSectionId] = useState(null);
  const [rowNumber, setRowNumber] = useState();
  const [isContinueProocess, setIsContinueProcess] = useState(false);
  const [videoDetail, setVideoDetail] = useState({
    publicVideoId: "",
    sectionId: "",
  });
  const [sectionModel, setSectionModel] = useState({
    sectionName: "",
    description: "",
    courseId: slug,
  });
  const [userRole, setUserRole] = useState([]);

  const [evaluateModel, setEvaluateModel] = useState({
    courseId: slug,
    courseEvaluateStatus: Number,
    courseEvaluateDescription: String,
  });
  const [videoId, setVideoId] = useState(
    buttonRef.current ? buttonRef.current.dataset.value : ""
  );
  const [unassignedVideos, setUnassignedVideos] = useState([]);
  const [showUnassignedModal, setShowUnassignedModal] = useState(false);
  const [currentSectionId, setCurrentSectionId] = useState(null);
  const [unassignedVideosLoading, setUnassignedVideosLoading] = useState(false); // Add loading state
  const [unassignedVideosError, setUnassignedVideosError] = useState(null); // Add error state
  
  // Modify the query to include skip option to manually control when it runs
  const { 
    data: unassignedVideosData, 
    refetch: refetchUnassignedVideos,
    isLoading: isUnassignedVideosLoading,
    isError: isUnassignedVideosError,
    error: unassignedVideosQueryError
  } = useGetUnAssignedVideosAsyncQuery(undefined, {
    // Use polling to periodically check for new data
    pollingInterval: 30000, // Poll every 30 seconds
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  
  // New state for video assignment
  const [assigningVideo, setAssigningVideo] = useState(false);
  const [selectedRowNumber, setSelectedRowNumber] = useState(1);
  const [videoTitle, setVideoTitle] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // Filter unassigned videos based on search query
  const filteredUnassignedVideos = useMemo(() => {
    if (!unassignedVideosData) return [];
    
    return unassignedVideosData.filter((video) => 
      video.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [unassignedVideosData, searchQuery]);

  // Enhanced function to fetch unassigned videos with better error handling
  const fetchUnassignedVideos = useCallback(async () => {
    try {
      setUnassignedVideosLoading(true);
      setUnassignedVideosError(null);
      await refetchUnassignedVideos();
    } catch (error) {
      console.error("Error fetching unassigned videos:", error);
      setUnassignedVideosError(error.message || "Failed to load videos");
      toast.error(t("Failed to load unassigned videos. Please try again."));
    } finally {
      setUnassignedVideosLoading(false);
    }
  }, [refetchUnassignedVideos, t]);

  // Fetch unassigned videos when component mounts and when modal is opened
  useEffect(() => {
    if (showUnassignedModal) {
      fetchUnassignedVideos();
    }
  }, [showUnassignedModal, fetchUnassignedVideos]);

  // Better handling of unassigned videos data
  useEffect(() => {
    if (unassignedVideosData) {
      setUnassignedVideos(unassignedVideosData);
    } else if (isUnassignedVideosError && unassignedVideosQueryError) {
      console.error("Error in unassigned videos query:", unassignedVideosQueryError);
      toast.error(t("Failed to load videos. Please try refreshing."));
    }
  }, [unassignedVideosData, isUnassignedVideosError, unassignedVideosQueryError, t]);

  useEffect(() => {
    if (data && data.result[0] && data.result[0].sections) {
      localStorage.setItem("sections", JSON.stringify(data.result[0].sections));
      setSections(data.result[0].sections);
    }
  }, [data]);

  if (isLoading) {
    return <IsLoading />;
  }

  const handleClickWatchingVideo = async (publicVideoId) => {
    try {
      const response = await watchingVideo(publicVideoId).unwrap();
      console.log("Video API response:", response);
      
      // Response'dan video URL'ini al
      const videoUrl = response?.result || response;
      
      if (videoUrl) {
        console.log("Video URL:", videoUrl);
        // Önce modal'ı aç
        setChooseVideo(true);
        
        // Modal açıldıktan sonra video'yu yükle
        setTimeout(() => {
          if (videoRef.current) {
            videoRef.current.src = videoUrl;
            videoRef.current.load();
            videoRef.current.play().catch(err => {
              console.error("Video play error:", err);
              // Autoplay engellenmiş olabilir, kullanıcı play butonuna basmalı
            });
          }
        }, 100);
      } else {
        console.error("Video URL bulunamadı");
        toast.error(t("Video URL not found"));
      }
    } catch (error) {
      console.error("Video yükleme hatası:", error);
      toast.error(t("Failed to load video"));
    }
  };

  const closeVideo = () => {
    setChooseVideo(false);

  };

  const removeItem = async (itemId, itemName) => {
    var answer = window.confirm(t("Are you sure want to delete?"));

    if (itemName === "video") {
      if (answer) {
        try {
          const response = await removeVideoAsync(itemId).unwrap();
          
          if (response?.isSuccess) {
            // State'i güncelle - silinen videoyu kaldır
            setSections(prevSections => 
              prevSections.map(section => ({
                ...section,
                videos: section.videos.filter(video => video.publicVideoId !== itemId)
              }))
            );
            
            // localStorage'ı güncelle
            const updatedSections = sections.map(section => ({
              ...section,
              videos: section.videos.filter(video => video.publicVideoId !== itemId)
            }));
            localStorage.setItem("sections", JSON.stringify(updatedSections));
            
            toast.success(t("Video removed successfully"));
            dispatch(instructorApi.util.invalidateTags(["instructor"]));
          }
        } catch (error) {
          console.error("Video silme hatası:", error);
          toast.error(t("Failed to remove video"));
        }
      }
    } else if (itemName === "section") {
      if (answer) {
        try {
          const response = await removeSectionAsync(itemId).unwrap();
          
          if (response?.isSuccess) {
            // State'i güncelle - silinen section'ı kaldır
            setSections(prevSections => 
              prevSections.filter(section => section.sectionId !== itemId)
            );
            
            // localStorage'ı güncelle
            const updatedSections = sections.filter(section => section.sectionId !== itemId);
            localStorage.setItem("sections", JSON.stringify(updatedSections));
            
            toast.success(t("Section removed successfully"));
            dispatch(instructorApi.util.invalidateTags(["instructor"]));
          }
        } catch (error) {
          console.error("Section silme hatası:", error);
          toast.error(t("Failed to remove section"));
        }
      }
    }
  };
  const handleDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const newSections = Array.from(sections);
    const [movedSection] = newSections.splice(result.source.index, 1);
    newSections.splice(result.destination.index, 0, movedSection);

    setSections(newSections);
    localStorage.setItem("sections", JSON.stringify(newSections));

    var storeSections = localStorage.getItem("sections");
    var sectionDataList = [];
    for (let index = 0; index < JSON.parse(storeSections).length; index++) {
      const element = JSON.parse(storeSections)[index];
      element.sequenceNumber = index;
      sectionDataList.push(element);
    }

    await updateSectionRows(sectionDataList).then((response) => {
      sectionDataList = [];
    });
  };

  const handleClickEdit = (sectionId) => {
    setEditingSectionId(editingSectionId === sectionId ? null : sectionId);
  };
  const handleOpenCustomModal = (title) => {
    isShowModal(!modal);
    setTitle(title);
  };

  const clickDownloadFile = async (fileUrl) => {
    var materialModel = {
      fileUrl: fileUrl,
      type: 1,
    };

    await downloadFile(materialModel).then((response) => {
      if (response.data.isSuccess) {
        const fileName = fileUrl; // Dosya ismi
    const fileExtension = fileName.split('.').pop(); // Dosya uzantısını al
    let mimeType = '';

    switch (fileExtension) {
      case 'pdf':
        mimeType = 'application/pdf';
        break;
      case 'jpg':
      case 'jpeg':
        mimeType = 'image/jpeg';
        break;
      case 'png':
        mimeType = 'image/png';
        break;
      case 'txt':
        mimeType = 'text/plain';
        break;
      case 'doc':
        mimeType = 'application/msword';
        break;
      case 'docx':
        mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      default:
        mimeType = 'application/octet-stream'; // Genel bir binary dosya tipi
        break;
    }

    // Dosya için base64 URI oluşturma
    const linkSource = `data:${mimeType};base64,${response.data.result}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
                toast.success("Download process is success completed")
      }
    });
  };

  const handleFromChildData = async (event) => {
    isShowModal(false);
    setIsContinueProcess(true);
    const formData = new FormData();
    const typeFile = event.file.target.files[0].type.split("/");
    if (
      (title == "ChangeVideo" || title == "NewVideo") &&
      typeFile[1] !== "mp4"
    ) {
      return alert("Please just mp4 format");
    }

    if (title == "ChangeVideo" || title == "NewVideo") {
      formData.append("File", event.file.target.files[0]);
      formData.append("Title", event.title);
      formData.append("RowNumberForSection", event.rowNumber);
      formData.append("SectionId", videoDetail.sectionId);
    }

    if (title == "NewMaterial") {
      formData.append("Name", event.title);
      formData.append("FileUrl", "");
      formData.append("VideoId", videoId);
      formData.append("File", event.file.target.files[0]);
    }

    const fileName = videoDetail.publicVideoId;

    if (title == "ChangeVideo") {
      await changeVideoAsync({ fileName, formData }).then((response) => {
        setLoading(true);

        if (response.data.isSuccess) {
          toast.success("Change Video Succeded");
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          setLoading(false);
          isShowModal(false);
          setIsContinueProcess(false);
        } else {
          setLoading(false);
          setIsContinueProcess(false);
        }
      });
    } else if (title == "NewMaterial") {
      await uploadMaterialAsync(formData).then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.messages[0]);
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          isShowModal(false);
          setIsContinueProcess(false);
        }
      });
    } else {
      await addVideoAsync(formData).then((response) => {
        if (response.data.isSuccess) {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          isShowModal(false);
          toast.success(response.data.messages[0]);
          setLoading(false);
          setIsContinueProcess(false);
        } else {
          setLoading(false);
          setIsContinueProcess(false);
        }
      });
    }
  };

  const handleAuthForRoles = async (event) => {
    setUserRole(event.role);
  };

  const createSection = async () => {
    try {
      const response = await createSectionAsync(sectionModel).unwrap();
      
      if (response && response.isSuccess) {
        handleClose();
        
        // Yeni section'ı state'e ekle
        const newSection = {
          sectionId: response.result?.sectionId || Date.now().toString(),
          sectionName: sectionModel.sectionName,
          description: sectionModel.description,
          courseId: slug,
          videos: [],
          sequenceNumber: sections.length
        };
        
        setSections(prevSections => [...prevSections, newSection]);
        
        // localStorage'ı güncelle
        const updatedSections = [...sections, newSection];
        localStorage.setItem("sections", JSON.stringify(updatedSections));
        
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
        toast.success(t("Section created successfully"));
        
        // Form'u temizle
        setSectionModel({
          sectionName: "",
          description: "",
          courseId: slug,
        });
      }
    } catch (error) {
      console.error("Section oluşturma hatası:", error);
      toast.error(t("Failed to create section"));
    }
  };

  const handleUpdateSection = async (sectionId) => {
    const sectionUpdateModel = {
      sectionName: sectionModel.sectionName,
      description: sectionModel.description,
    };

    try {
      const response = await updateSectionAsync({ sectionId, sectionUpdateModel }).unwrap();
      
      if (response && response.isSuccess) {
        // State'i güncelle - section bilgilerini güncelle
        setSections(prevSections => 
          prevSections.map(section => 
            section.sectionId === sectionId 
              ? { 
                  ...section, 
                  sectionName: sectionModel.sectionName,
                  description: sectionModel.description
                }
              : section
          )
        );
        
        // localStorage'ı güncelle
        const updatedSections = sections.map(section => 
          section.sectionId === sectionId 
            ? { 
                ...section, 
                sectionName: sectionModel.sectionName,
                description: sectionModel.description
              }
            : section
        );
        localStorage.setItem("sections", JSON.stringify(updatedSections));
        
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
        toast.success(t("Section updated successfully"));
        setIsEnable(!isEnable);
        setEditingSectionId(null);
        setSectionModel({
          sectionName: "",
          description: "",
          courseId: slug,
        });
      }
    } catch (error) {
      console.error("Section güncelleme hatası:", error);
      toast.error(t("Failed to update section"));
    }
  };

  const handleRemoveFile = async (fileName) => {
    var answer = window.confirm(t("Are you sure want to delete?"));

    if (answer) {
      try {
        const response = await removeMaterialAsync(fileName).unwrap();
        
        if (response && response.isSuccess) {
          // State'i güncelle - silinen material'ı kaldır
          setSections(prevSections => 
            prevSections.map(section => ({
              ...section,
              videos: section.videos.map(video => ({
                ...video,
                materials: video.materials.filter(material => material.fileUrl !== fileName)
              }))
            }))
          );
          
          // localStorage'ı güncelle
          const updatedSections = sections.map(section => ({
            ...section,
            videos: section.videos.map(video => ({
              ...video,
              materials: video.materials.filter(material => material.fileUrl !== fileName)
            }))
          }));
          localStorage.setItem("sections", JSON.stringify(updatedSections));
          
          toast.success(t("Material removed successfully"));
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
        }
      } catch (error) {
        console.error("Material silme hatası:", error);
        toast.error(t("Failed to remove material"));
      }
    }
  };

  const handleSendEvaluate = async (model) => {
    if (model.returnEvaluate === undefined) {
      if (data.result[0].userId === userId) {
        //here is in the send to for evaluate instructor
        //this reason enums value is =

        dispatch(instructorApi.util.invalidateTags(["course"]));
        // setEvaluateModel({
        //   courseId:slug,
        //   courseEvaluateStatus:courseEvaluateEnum.InEvaluation,
        //   courseEvaluateDescription:"Send To Evaluate"
        // })

        const evaluationModel = {
          courseId: slug,
          CourseEvaluteStatus: courseEvaluateEnum.InEvaluation,
          courseEvaluateDescription: "Send To Evaluate",
        };

        await updateEvaluate(evaluationModel).then((response) => {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
        });
      }
    } else {
      const evaluationModel = {
        courseId: slug,
        CourseEvaluteStatus: model.returnEvaluate.statu,
        courseEvaluateDescription: model.returnEvaluate.description,
      };

      await updateEvaluate(evaluationModel).then((response) => {
        if (response.data.isSuccess) {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          setEvaluateModal(false);
        } else {
          toast.error("Ooops!sometihng went wrong");
        }
      });
    }
  };

  const handleClickedVideo = (videoId) => {
    if (handleClickedUpdateRows === false) {
      setSelectedVideoId(videoId);
      setHandleClickedUpdateRows(!handleClickedUpdateRows);
    } else {
      setSelectedVideoId(null);
      setHandleClickedUpdateRows(!handleClickedUpdateRows);
    }
  };

  const handleUpdateVideo = async (videoId) => {
    const updateVideoModel = {
      rowNumberForSection: rowNumber,
    };


    await updateVideoAsync({ videoId, updateVideoModel }).then((response) => {
      if (response.data.isSuccess) {
        toast.success("Video Updated Successfully");
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
        setHandleClickedUpdateRows(false);
      } else {
        toast.error(response.data.messages[0]);
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
      }
    });
  };

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver 
      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" 
      : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    padding: "24px",
    borderRadius: "16px",
    boxShadow: isDraggingOver 
      ? "0 10px 40px rgba(102, 126, 234, 0.4)" 
      : "0 4px 12px rgba(0, 0, 0, 0.08)",
    transition: "all 0.3s ease",
    minHeight: "100px",
    border: isDraggingOver 
      ? "2px dashed rgba(255, 255, 255, 0.6)" 
      : "2px solid transparent",
  });

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    background: isDragging 
      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" 
      : "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
    padding: "0",
    marginBottom: "16px",
    borderRadius: "12px",
    boxShadow: isDragging 
      ? "0 20px 60px rgba(102, 126, 234, 0.5)" 
      : "0 4px 12px rgba(0, 0, 0, 0.1)",
    border: isDragging 
      ? "2px solid rgba(255, 255, 255, 0.8)" 
      : "2px solid #e9ecef",
    transform: isDragging ? "scale(1.05) rotate(2deg)" : "scale(1)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    overflow: "hidden",
    ...draggableStyle,
  });

  const renderButton = () => {
    if (
      data.result[0].userId === userId &&
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.Pending
    ) {
      return (
        <Button className="btn btn-danger" onClick={handleSendEvaluate}>
          Send Evaluate
        </Button>
      );
    }
    if (
      data.result[0].userId === userId &&
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.InRevision
    ) {
      return (
        <>
          <Button className="btn btn-danger" onClick={handleSendEvaluate}>
            ReSend Evaluate
          </Button>
          <Button
            className="btn btn-warning"
            onClick={() => setEvaluateModal(!evaluateModal)}
          >
            Read The Description
          </Button>
        </>
      );
    } else if (
      userRole.includes(Roles.SuperVisor) &&
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.InEvaluation
    ) {
      return (
        <Button
          className="btn btn-success"
          onClick={() => setEvaluateModal(!evaluateModal)}
        >
          Evaluate
        </Button>
      );
    } else if (
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.Accept ||
      ((userRole.includes(Roles.SuperVisor) ||
        data.result[0].userId !== userId) &&
        data.result[0].courseEvaluteStatus === courseEvaluateEnum.Accept)
    ) {
      return (
        <Button className="btn btn-success" disabled>
          {t("Course Is Published")}
        </Button>
      );
    } else if (
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.Cancel
    ) {
      return (
        <>
          <Button className="btn btn-danger" disabled>
            {t("Course is rejected")}
          </Button>
          <Button
            className="btn btn-warning"
            onClick={() => setEvaluateModal(!evaluateModal)}
          >
            Read The Description
          </Button>
        </>
      );
    } else {
      return (
        <Button className="btn btn-warning" disabled>
          Sended to evaluate
        </Button>
      );
    }
  };

  const handleAssignVideo = async (videoId, publicVideoId, defaultVideoTitle) => {
    setAssigningVideo(true);
    
    try {
      const section = sections.find(s => s.sectionId === currentSectionId);
      if (!section) {
        toast.error(t("Section not found"));
        setAssigningVideo(false);
        return;
      }

      // Önce, insertion position'dan sonraki tüm videoların row number'larını 1 artır
      const videosToUpdate = section.videos.filter(v => v.rowNumberForSection >= selectedRowNumber);
      
      // Her videoyu sırayla güncelle (sondan başa doğru, çakışma olmasın diye)
      const sortedVideos = videosToUpdate.sort((a, b) => b.rowNumberForSection - a.rowNumberForSection);
      
      for (const video of sortedVideos) {
        const updateModel = {
          rowNumberForSection: video.rowNumberForSection + 1
        };
        await updateVideoAsync({ videoId: video.videoId, updateVideoModel: updateModel }).unwrap();
      }

      // Şimdi yeni videoyu assign et - videoTitle state kullan, boşsa default title kullan
      const finalTitle = videoTitle.trim() || defaultVideoTitle;
      const bulkVideoAssignModel = {
        RowNumberForSection: selectedRowNumber,
        title: finalTitle,
        sectionId: currentSectionId,
        videoId: videoId
      };

      const response = await updateAssignVideoAsync(bulkVideoAssignModel).unwrap();
      
      if (response && response.isSuccess) {
        toast.success(t("Video assigned successfully"));
        setShowUnassignedModal(false);
        refetchUnassignedVideos();
        
        // Cache'i invalidate et - bu otomatik olarak course detail'i yeniden yükleyecek
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
      } else {
        toast.error(response?.messages?.[0] || t("Failed to assign video"));
      }
    } catch (error) {
      toast.error(t("Error assigning video"));
      console.error(error);
      // Hata durumunda cache'i yenile
      dispatch(instructorApi.util.invalidateTags(["instructor"]));
    } finally {
      setAssigningVideo(false);
    }
  };

  const openUnassignedVideosModal = (sectionId) => {
    setCurrentSectionId(sectionId);
    setSearchQuery(""); // Reset search when opening modal
    setShowUnassignedModal(true);
    // Fetch videos immediately when modal opens
    fetchUnassignedVideos();
  };

  const handleInsertVideoAtPosition = (sectionId, insertPosition) => {
    setCurrentSectionId(sectionId);
    setSelectedRowNumber(insertPosition);
    setVideoTitle("");
    setSearchQuery("");
    setShowUnassignedModal(true);
    fetchUnassignedVideos();
  };

  const moveVideoUp = async (videoId, sectionId, currentRow) => {
    if (currentRow <= 1) return; // Zaten en üstte

    try {
      const section = sections.find(s => s.sectionId === sectionId);
      if (!section) return;

      const currentVideo = section.videos.find(v => v.videoId === videoId);
      const targetRow = currentRow - 1;
      const targetVideo = section.videos.find(v => v.rowNumberForSection === targetRow);
      
      if (!currentVideo || !targetVideo) return;

      // Step 1: Üstteki videoyu geçici bir row'a taşı (maksimum row + 1)
      const tempRow = Math.max(...section.videos.map(v => v.rowNumberForSection)) + 1;
      const step1Model = { rowNumberForSection: tempRow };
      await updateVideoAsync({ videoId: targetVideo.videoId, updateVideoModel: step1Model }).unwrap();

      // Step 2: Mevcut videoyu hedef row'a taşı
      const step2Model = { rowNumberForSection: targetRow };
      await updateVideoAsync({ videoId: currentVideo.videoId, updateVideoModel: step2Model }).unwrap();

      // Step 3: Geçici row'daki videoyu eski row'a taşı
      const step3Model = { rowNumberForSection: currentRow };
      await updateVideoAsync({ videoId: targetVideo.videoId, updateVideoModel: step3Model }).unwrap();

      // State'i güncelle
      setSections(prevSections => 
        prevSections.map(sec => {
          if (sec.sectionId === sectionId) {
            const updatedVideos = sec.videos.map(video => {
              if (video.videoId === currentVideo.videoId) {
                return { ...video, rowNumberForSection: targetRow };
              }
              if (video.videoId === targetVideo.videoId) {
                return { ...video, rowNumberForSection: currentRow };
              }
              return video;
            });
            return { ...sec, videos: updatedVideos.sort((a, b) => a.rowNumberForSection - b.rowNumberForSection) };
          }
          return sec;
        })
      );

      toast.success(t("Video moved up"));
      dispatch(instructorApi.util.invalidateTags(["instructor"]));
    } catch (error) {
      console.error("Video yukarı taşıma hatası:", error);
      toast.error(t("Failed to move video"));
      // Hata durumunda sayfayı yenile
      dispatch(instructorApi.util.invalidateTags(["instructor"]));
    }
  };

  const moveVideoDown = async (videoId, sectionId, currentRow, totalVideos) => {
    if (currentRow >= totalVideos) return; // Zaten en altta

    try {
      const section = sections.find(s => s.sectionId === sectionId);
      if (!section) return;

      const currentVideo = section.videos.find(v => v.videoId === videoId);
      const targetRow = currentRow + 1;
      const targetVideo = section.videos.find(v => v.rowNumberForSection === targetRow);
      
      if (!currentVideo || !targetVideo) return;

      // Step 1: Alttaki videoyu geçici bir row'a taşı (maksimum row + 1)
      const tempRow = Math.max(...section.videos.map(v => v.rowNumberForSection)) + 1;
      const step1Model = { rowNumberForSection: tempRow };
      await updateVideoAsync({ videoId: targetVideo.videoId, updateVideoModel: step1Model }).unwrap();

      // Step 2: Mevcut videoyu hedef row'a taşı
      const step2Model = { rowNumberForSection: targetRow };
      await updateVideoAsync({ videoId: currentVideo.videoId, updateVideoModel: step2Model }).unwrap();

      // Step 3: Geçici row'daki videoyu eski row'a taşı
      const step3Model = { rowNumberForSection: currentRow };
      await updateVideoAsync({ videoId: targetVideo.videoId, updateVideoModel: step3Model }).unwrap();

      // State'i güncelle
      setSections(prevSections => 
        prevSections.map(sec => {
          if (sec.sectionId === sectionId) {
            const updatedVideos = sec.videos.map(video => {
              if (video.videoId === currentVideo.videoId) {
                return { ...video, rowNumberForSection: targetRow };
              }
              if (video.videoId === targetVideo.videoId) {
                return { ...video, rowNumberForSection: currentRow };
              }
              return video;
            });
            return { ...sec, videos: updatedVideos.sort((a, b) => a.rowNumberForSection - b.rowNumberForSection) };
          }
          return sec;
        })
      );

      toast.success(t("Video moved down"));
      dispatch(instructorApi.util.invalidateTags(["instructor"]));
    } catch (error) {
      console.error("Video aşağı taşıma hatası:", error);
      toast.error(t("Failed to move video"));
      // Hata durumunda sayfayı yenile
      dispatch(instructorApi.util.invalidateTags(["instructor"]));
    }
  };

  if (isContinueProocess) {
    return isContinueProocess ? (
      <div>
        <IsLoading text={"Please waiting your while processing"}></IsLoading>
      </div>
    ) : (
      ""
    );
  } else {
    return (
      <div>
        {}

        <Fragment>
          <Navbar onAuthData={handleAuthForRoles} />
          <PageTitle pageTitle={t("Instructor")} pageSub={"CourseDetail"} />
    

          {modal ? (
            <CustomModal
              props={modal}
              changeVideoObject={videoDetail}
              type={title}
              onData={handleFromChildData}
            />
          ) : (
            ""
          )}

          {evaluateModal ? (
            <EvaluateModal
              props={evaluateModal}
              status={data}
              onData={handleSendEvaluate}
            ></EvaluateModal>
          ) : (
            ""
          )}
          <div>
            <div className="row">
              <div className="col">
                <Button onClick={handleOpen}>{t("Create New Section")}</Button>

                {renderButton()}
              </div>
            </div>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  <div className="col">
                    <div className="row">
                      <Input
                        type="text"
                        placeholder="Section Name"
                        onChange={(e) =>
                          setSectionModel({
                            ...sectionModel,
                            sectionName: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="row">
                      <Input
                        type="text"
                        placeholder="Description"
                        onChange={(e) =>
                          setSectionModel({
                            ...sectionModel,
                            description: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <Button onClick={createSection}>Save Section</Button>
                </Typography>
              </Box>
            </Modal>
          </div>

          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable-sections">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {sections.map((section, index) => (
                    <Draggable
                      key={section.sectionId}
                      draggableId={section.sectionId}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <Accordion>
                            <Accordion.Item
                              eventKey={section.sectionId}
                              key={section.sectionId}
                              className="section-drag-item"
                            >
                              <Accordion.Header className="accordion-header">
                                <span className="section-drag-handle" title={t("Drag to reorder")}></span>
                                
                                <input
                                  className="section-input-field"
                                  defaultValue={section.sectionName}
                                  disabled={editingSectionId !== section.sectionId}
                                  onChange={(e) =>
                                    setSectionModel({
                                      ...sectionModel,
                                      sectionName: e.target.value,
                                    })
                                  }
                                  placeholder={t("Section Name")}
                                />
                                
                                <input
                                  className="section-input-field"
                                  defaultValue={section.description}
                                  onChange={(e) =>
                                    setSectionModel({
                                      ...sectionModel,
                                      description: e.target.value,
                                    })
                                  }
                                  disabled={editingSectionId !== section.sectionId}
                                  placeholder={t("Description")}
                                />
                                
                                <div className="section-action-buttons-group">
                                  <button
                                    className="section-action-btn section-edit-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickEdit(section.sectionId);
                                    }}
                                    onMouseEnter={() => {
                                      setSectionModel({
                                        ...sectionModel,
                                        description: section.description,
                                        sectionName: section.sectionName,
                                      });
                                    }}
                                    title={t("Edit Section")}
                                  >
                                    <IoPencil /> {t("Edit")}
                                  </button>
                                  
                                  {editingSectionId === section.sectionId && (
                                    <button
                                      className="section-action-btn section-update-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleUpdateSection(section.sectionId);
                                      }}
                                    >
                                      ✓ {t("Update")}
                                    </button>
                                  )}
                                  
                                  <button
                                    className="section-action-btn section-remove-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeItem(section.sectionId, "section");
                                    }}
                                    title={t("Remove Section")}
                                  >
                                    <FiTrash2 /> {t("Remove")}
                                  </button>
                                </div>
                              </Accordion.Header>

                              {/* Video insertion zone at the start */}
                              <Accordion.Body>
                                <div 
                                  className="video-insert-zone"
                                  onClick={() => handleInsertVideoAtPosition(section.sectionId, 1)}
                                >
                                  <div className="insert-zone-content">
                                    <FiPlus className="insert-icon" />
                                    <span className="insert-text">{t("Add video here")}</span>
                                  </div>
                                </div>
                              </Accordion.Body>

                              {section.videos.map((video, videoIndex) => (
                                <Fragment key={video.videoId}>
                                  <Accordion.Body>
                                    <div className="video-item-wrapper">
                                      <div className="video-info-section">
                                        <div className="video-header">
                                          <span className="video-number">{video.rowNumberForSection}</span>
                                          <h4 className="video-title">{video.title}</h4>
                                          
                                          {/* Video sıralama butonları */}
                                          <div className="video-order-controls">
                                            <button
                                              className="btn-order btn-order-up"
                                              onClick={() => moveVideoUp(video.videoId, section.sectionId, video.rowNumberForSection)}
                                              disabled={videoIndex === 0}
                                              title={t("Move Up")}
                                            >
                                              <FiChevronUp />
                                            </button>
                                            <button
                                              className="btn-order btn-order-down"
                                              onClick={() => moveVideoDown(video.videoId, section.sectionId, video.rowNumberForSection, section.videos.length)}
                                              disabled={videoIndex === section.videos.length - 1}
                                              title={t("Move Down")}
                                            >
                                              <FiChevronDown />
                                            </button>
                                          </div>
                                        </div>
                                        
                                        <div className="video-actions">
                                          <button
                                            className="btn-action btn-watch"
                                            onClick={() => handleClickWatchingVideo(video.publicVideoId)}
                                            title={t("Watch Video")}
                                          >
                                            <FiPlay /> {t("Watch")}
                                          </button>
                                          
                                          <button
                                            className="btn-action btn-edit"
                                            onClick={() => {
                                              setVideoDetail({
                                                publicVideoId: video.publicVideoId,
                                                sectionId: section.sectionId,
                                                rowNumber: video.rowNumberForSection,
                                                videoName: video.title,
                                              });
                                              handleOpenCustomModal("ChangeVideo");
                                            }}
                                            title={t("Change Video")}
                                          >
                                            <FiEdit2 /> {t("Change")}
                                          </button>
                                          
                                          <button
                                            className="btn-action btn-delete"
                                            onClick={() => removeItem(video.publicVideoId, "video")}
                                            title={t("Remove Video")}
                                          >
                                            <FiTrash2 /> {t("Remove")}
                                          </button>
                                        </div>
                                      </div>

                                      {/* Materials Section */}
                                      <div className="materials-section">
                                        {video.materials.length > 0 ? (
                                          <div className="materials-list">
                                            <h5 className="materials-title">
                                              <FiDownload /> {t("Materials")}
                                            </h5>
                                            {video.materials.map((material, idx) => (
                                              <div key={idx} className="material-item">
                                                <span className="material-name">{material.name}</span>
                                                <div className="material-actions">
                                                  <button
                                                    className="btn-material btn-download"
                                                    onClick={() => clickDownloadFile(material.fileUrl)}
                                                  >
                                                    <FiDownload /> {t("Download")}
                                                  </button>
                                                  <button
                                                    className="btn-material btn-remove"
                                                    onClick={() => handleRemoveFile(material.fileUrl)}
                                                  >
                                                    <FiX /> {t("Remove")}
                                                  </button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <button
                                            className="btn-add-material"
                                            onClick={() => {
                                              handleOpenCustomModal("NewMaterial");
                                              setVideoId(video?.videoId);
                                            }}
                                          >
                                            <FiPlus /> {t("Add Material")}
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </Accordion.Body>

                                  {/* Video insertion zone after each video */}
                                  <Accordion.Body>
                                    <div 
                                      className="video-insert-zone"
                                      onClick={() => handleInsertVideoAtPosition(section.sectionId, video.rowNumberForSection + 1)}
                                    >
                                      <div className="insert-zone-content">
                                        <FiPlus className="insert-icon" />
                                        <span className="insert-text">{t("Add video here")}</span>
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                </Fragment>
                              ))}
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <Modal
            open={showUnassignedModal}
            onClose={() => setShowUnassignedModal(false)}
            aria-labelledby="unassigned-videos-modal-title"
            aria-describedby="unassigned-videos-modal-description"
          >
            <Box sx={modalStyle}>
              <Typography 
                id="unassigned-videos-modal-title" 
                variant="h6" 
                component="h2" 
                sx={{ 
                  mb: 3,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  borderBottom: '1px solid #eee',
                  paddingBottom: '10px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {t("Unassigned Videos")}
                {/* Add refresh button */}
                <Button 
                  variant="text"
                  color="primary"
                  sx={{ ml: 2 }}
                  onClick={fetchUnassignedVideos}
                  disabled={isUnassignedVideosLoading || unassignedVideosLoading}
                >
                  <IoRefresh size={24} />
                </Button>
              </Typography>
              
              {(isUnassignedVideosLoading || unassignedVideosLoading) ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                  <Spinner />
                  <span style={{ marginLeft: '10px' }}>{t("Loading videos...")}</span>
                </div>
              ) : unassignedVideosError || isUnassignedVideosError ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <Typography variant="body1" color="error">
                    {t("Failed to load videos")}
                  </Typography>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={fetchUnassignedVideos}
                    sx={{ mt: 2 }}
                  >
                    {t("Try Again")}
                  </Button>
                </div>
              ) : unassignedVideosData && unassignedVideosData.length > 0 ? (
                <div>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {t("Select a video to add to this section")}
                  </Typography>
                  
                  {/* Video Title Input */}
                  <div style={{ marginBottom: '20px' }}>
                    <Typography variant="body2" sx={{ mb: 1, fontWeight: '500' }}>
                      {t("Video Title")} (optional):
                    </Typography>
                    <Input 
                      type="text" 
                      placeholder={t("Enter custom title or leave empty to use original")} 
                      value={videoTitle}
                      onChange={(e) => setVideoTitle(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '10px 12px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                      }}
                    />
                  </div>

                  {/* Add search input */}
                  <div style={{ marginBottom: '20px' }}>
                    <Input
                      type="text"
                      placeholder={t("Search videos...")}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                      }}
                    />
                  </div>
                  
                  <div style={{ maxHeight: '400px', overflow: 'auto' }}>
                    {filteredUnassignedVideos.length > 0 ? (
                      filteredUnassignedVideos.map((video) => (
                        <div 
                          key={video.videoId} 
                          style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            padding: '12px',
                            marginBottom: '10px',
                            border: '1px solid #eee',
                            borderRadius: '8px',
                            backgroundColor: '#f9f9f9'
                          }}
                        >
                          <div>
                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                              {video.title}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              ID: {video.publicVideoId}
                            </Typography>
                          </div>
                          <Button 
                            variant="contained"
                            color="primary"
                            onClick={() => handleAssignVideo(video.videoId, video.publicVideoId, video.title)}
                            disabled={assigningVideo}
                          >
                            {assigningVideo ? <Spinner size="sm" /> : t("Add to Section")}
                          </Button>
                        </div>
                      ))
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px' }}>
                        <Typography variant="body1">
                          {t("No videos found matching your search")}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <Typography variant="body1">
                    {t("No unassigned videos available")}
                  </Typography>
                </div>
              )}
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button 
                  onClick={() => {
                    setVideoDetail({
                      ...videoDetail,
                      sectionId: currentSectionId,
                      rowNumber: selectedRowNumber,  // Row number da set edilsin
                    });
                    handleOpenCustomModal("NewVideo");
                    setShowUnassignedModal(false);
                  }}
                  variant="outlined"
                >
                  {t("Upload New Video")}
                </Button>
                
                <Button 
                  onClick={() => setShowUnassignedModal(false)}
                  variant="contained"
                  color="secondary"
                >
                  {t("Close")}
                </Button>
              </Box>
            </Box>
          </Modal>

          {/* Video Player Modal */}
          {chooseVideo && (
            <div className="video-player-modal" onClick={() => closeVideo()}>
              <div className="video-player-container" onClick={(e) => e.stopPropagation()}>
                <button 
                  className="video-player-close"
                  onClick={() => closeVideo()}
                >
                  <FiX /> {t("Close")}
                </button>
                <VideoRefContext.Provider value={videoRef}>
                  <video
                    className="video-player"
                    loop
                    autoPlay
                    ref={videoRef}
                    controls
                    controlsList="nodownload"
                    style={{ width: '100%', maxHeight: '80vh', borderRadius: '8px' }}
                  >
                    {t("Your browser does not support the video tag.")}
                  </video>
                </VideoRefContext.Provider>
              </div>
            </div>
          )}

          <Footer />
          <Scrollbar />
        </Fragment>
      </div>
    );
  }
}

export default InstructorAuth(InstructorsCourseDetail);
